import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsFormDoesNotExistSvg = lazy(
  () => import('./svg-components/digital-forms-form-does-not-exist-svg')
);

const DigitalFormsFormDoesNotExistSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsFormDoesNotExistSvg {...rest} />
  </Suspense>
);

export default DigitalFormsFormDoesNotExistSvg;
